import { DpFanStagesState } from '@/data/Content/DpFanStages/state';

export const LOCAL_STORAGE_DP_FAN_STATE_KEY = 'dpFanState';

export const getLocalStorageDpFanState = () => localStorage.getItem(LOCAL_STORAGE_DP_FAN_STATE_KEY);

export const setLocalStorageDpFanState = (state: DpFanStagesState) =>
	localStorage.setItem(LOCAL_STORAGE_DP_FAN_STATE_KEY, JSON.stringify(state));

export const removeLocalStorageDpFanState = () =>
	localStorage.removeItem(LOCAL_STORAGE_DP_FAN_STATE_KEY);
